import { Color, Vector3 } from 'three';

//  Grid3D!!
export const Grid3D = ({ scale, size, divisions, color, opacity, x, y, z }) => {
    return (
        <gridHelper
            scale={scale}
            position={new Vector3(x, y, z)}
            args={[size, divisions, new Color(color), new Color(color)]}
        />
    );
}

export default Grid3D;